import { faComments } from "@fortawesome/free-solid-svg-icons/faComments";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { AtiraEmpty } from "../../../../components/AtiraEmpty";
import { Text } from "../../../../components/Text";
import { TestIDs } from "../../../../tests/types/testIds";
import { Spacing } from "../../../../theme/Spacing";

const Wrapper = styled.div`
  flex: 1;
  width: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${Spacing.s};
  padding: ${Spacing.l};
  text-align: center;
`;

export const WAEmptyThread: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Wrapper data-testid={TestIDs.integration.whatsappMeta.chat.emptyThread}>
      <AtiraEmpty
        icon={faComments}
        iconHeight="72px"
        description={t("integration.whatsapp.meta.thread.empty.title")}
      />

      <Text color="darkerSub" fontSize="s" align="center">
        {t("integration.whatsapp.meta.thread.empty.hint")}
      </Text>
    </Wrapper>
  );
};
